import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import 'rxjs/add/operator/map';
import * as moment from 'moment';
import { Pallets } from '../model/Pallets';
import { FilterUrlService } from './filter-url.service';

@Injectable()
export class PalletsService {
  url:string = GLOBAL.url+"pallets";
  filter:string;

  constructor( private http:HttpClient, private _urlService:FilterUrlService ) {
    this._urlService.filters.subscribe(new_filter => this.filter = new_filter );
  }
  /**
  * Obtiene el listado de 10 elementos.
  * @return listado de clientes o un error.
  */
  public get(){
    return this.http.get(this.url+this.filter ).map( res => {
      return res;
    });
  }

  public getDataFiltered(filters){
    let url = this.url+filters;
    return this.http.get(url).map( res => {
        return res;
    });
  }

  /**
  * Obtiene el listado de todos los elementos.
  * @return listado de clientes o un error.
  */
  public getAll(){
    let url = this.url+'?sort=-prefix,--suffix&limit=10000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado de todos los pallets genéricos
  * @return listado de clientes o un error.
  */
  public getAllGenericPallets(){
    //let url = this.url+'?sort=-prefix,--suffix&limit=10000&number=><-0000-';
    let url = GLOBAL.url+'pallets_by_boxes?limit=10000&boxes=90&number=><-0000-';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado de todos los pallets dependiendo del prefijo
  * @return listado de clientes o un error.
  */
  public getAllPrefixPallets(prefijo:string){
    let url = this.url+'?sort=-prefix,--suffix&limit=10000&prefix=P'+prefijo;
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado de todos los pallets con espacio disponible.
  * @return listado de clientes o un error.
  */
  public getAllByBoxes(){
    let url = GLOBAL.url+'pallets_by_boxes?limit=10000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado de todos los pallets con espacio disponible de acuerdo al prefijo de la OP (Consulta en el STOCK)
  * @return listado de clientes o un error.
  */
  public getAllByBoxes2(p:string){
    //console.log("PREFIJO",p);
    let url = GLOBAL.url+'pallets_by_boxes?boxes=89&prefix=P'+p+'&limit=1000';
    //console.log("URL PETICION: ", url);
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene un elemento.
  * @return elemento o un error.
  */
  public getOne(id:string,id2:string){
    let url = GLOBAL.url+'pallets?prefix='+id+'&suffix='+id2;
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el numero de cajas almacenadas en un pallet.
  * @return elemento o un error.
  */
  public getCountStock(id:string,id2:string){
    let url = GLOBAL.url+'pallets_count_tags?prefix='+id+'&suffix='+id2;;
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  //

  /**
  * Obtiene un elemento.
  * @return elemento o un error.
  */
  public getOneByNumber(id:string){

    let url = GLOBAL.url+'pallets?number='+id;
    //console.log("URL PALLET: ", url);
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene un elemento.
  * @return elemento o un error.
  */
  public getbyLocation(id:string){
    let url = GLOBAL.url+'locations/'+id+'/pallets?limit=1000&sort=-id';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

    /**
    * Obtiene un elemento.
    * @return elemento o un error.
    */
    public getPalletMaxSuffix(id:string){
      let url = GLOBAL.url+'pallets?soft&prefix='+id+'&sort=-suffix&limit=1';
      return this.http.get(url ).map( res => {
        return res;
      });
    }

    public getPalletsByPrefix(id:string){
      let url = GLOBAL.url+'pallets?prefix='+id+'&sort=-suffix&limit=1000';
      return this.http.get(url ).map( res => {
        return res;
      });
    }

    public getEmptyPalletsByPrefix(id:string){
      let url = GLOBAL.url+'pallets_empty?prefix='+id+'&sort=-suffix&limit=1000';
      return this.http.get(url ).map( res => {
        return res;
      });
    }

    /**
    * Obtiene el detalles de las cajas dentro del pallet.
    * @return detalles o un error.
    */
    public getPalletDetails(id:string){
      let url = GLOBAL.url+'pallets/'+id+'/summary?&limit=90';
      return this.http.get(url ).map( res => {
        return res;
      });
    }

    /**
    * Obtiene los pallets nuevos sin cajas dentro del pallet.
    * @return listado de pallets o un error.
    */
    public getNewPallets(){
      let url = GLOBAL.url+'pallets_empty?limit=10000&sort=-number';
      return this.http.get(url ).map( res => {
        return res;
      });
    }

  /**
  * Envia un POST para almacenar información.
  * @param  prov información a enviar
  * @return      respuesta de la peticion http
  */
  public save(prov:any){
    return this.http.post(this.url, prov)
    .map( data => {
      return data;
    });
  }

  /**
  * Actualiza un elemento en la base de datos
  * @param  url  url del elemento que se actualiza.
  * @param  body ¿?
  * @return      respuesta de la peticion http
  */
  public update(url:string, body){
    return this.http.put(url, body)
    .map( data => {return data;});
  }

  /**
  * Actualiza un pallet en la base de datos, debido a la entrada por packing.
  * @param  url  url del elemento que se actualiza.
  * @param  body ¿?
  * @return      respuesta de la peticion http
  */
  public update2(body,id){
    let url = GLOBAL.url+"pallets/"+id;
    return this.http.put(url, body)
    .map( data => {return data;});
  }

  /**
  * Elimina un registro de la base de datos
  * @param  url url del elemento que se elimina
  * @return     respuesta de la peticion http
  */
  public delete(url:string){
    return this.http.delete(url).map( response =>{
      return response;
    });
  }

  /**
  * Elimina un registro de la base de datos
  * @param  url url del elemento que se elimina
  * @return     respuesta de la peticion http
  */
  public delete2(id:number){
    let url = GLOBAL.url+'pallets/'+id;
    return this.http.delete(url).map( response =>{
      return response;
    });
  }

  /**
  * Envia un delete para almacenar información de varios cajas a la vez.
  * @param  prov información a enviar
  * @return      respuesta de la peticion http
  */
  public deleteAll(prov:any){
    let url = GLOBAL.url+"all_pallets_delete";
    return this.http.put(url, prov)
    .map( data => {
      return data;
    });
  }

  /**
  * Transforma una fecha (YYYY-MM-DD 00:00:00) para ser almacenada en una BD.
  * @param  fechas fecha a transformar
  * @return        fecha con el formato (YYYY-MM-DD 00:00:00)
  */
  transformDates(fechas:Date):String{
    let fecha = moment(fechas);
    //2018-02-28 00:00:00
    return (fecha.year()+'-'+(fecha.month()+1)+'-'+fecha.date()+' 00:00:00');
  }

  /**
  * Transforma un objeto a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData(data:any,prefix:string,suffix:number,idpallet:number){
    //id,qr,codigo,x,y,z,cantidad,prefix,suffix
    let p = new Pallets(idpallet,prefix+'-'+suffix+'-',prefix+'-'+suffix,0,0,0,data.amount,prefix,suffix);
    return p.getJson();
  }
  /**
  * Transforma un objeto a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData2(id:number,amount:number){
    //id,qr,codigo,x,y,z,cantidad,prefix,suffix
    let p = new Pallets(0,0,0,0,0,0,0,0,0);
    return p.getJson2(id,amount);
  }
  /**
  * Transforma un objeto a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData3(pa:any){
    //id,qr,codigo,x,y,z,cantidad,prefix,suffix
    let p = new Pallets(pa.id,pa.qr,pa.codigo,0,0,0,pa.cantidad,pa.prefijo,pa.sufijo);
    return p.getJson();
  }

  transformData4(prefix:any){
    //id,qr,codigo,x,y,z,cantidad,prefix,suffix
    let p = new Pallets(-1,'','',0,0,0,0,prefix,0);
    return p.getJson3();
  }

  transformData5(pallets:any){
    let p = new Pallets(-1,'','',0,0,0,0,'',0);
    return p.getJson4(pallets);
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/pallets.service.ts